import { type Subscription } from 'rxjs'

class SubscriptionManager {
	private readonly subscriptions: Subscription[] = []

	addSubscription = (subscriptions: Subscription[]) => {
		this.subscriptions.push(...subscriptions)
	}

	unSubscribe = (timeout: number = 0) => {
		// This setTimeout is so the subscriptions can be unsubscribed after the store reducers have run
		setTimeout(() => {
			this.subscriptions.forEach(sub => sub.unsubscribe())
			this.subscriptions.splice(0, this.subscriptions.length)
		}, timeout)
	}
}

export const subscriptionManager = new SubscriptionManager()

export const { addSubscription, unSubscribe } = subscriptionManager
